var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img-lazy',{class:{ 'rounded-circle d-block': !_vm.imgSquare },attrs:{"src":_vm.imageSrc,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }